module.exports = __webpack_public_path__ + "static/img/Art.e6c99cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Art.png
// module id = 2231
// module chunks = 61